// src/services/stake.service.ts
import { createApiClient } from "@/utils/api";
import { WithdrawalService } from "@/gen/api/v1/api_pb";
import type {
  ListWithdrawalsRequest,
  ListWithdrawalsResponse,
  CreateWithdrawalRequest,
  Withdrawal,
} from "@/gen/api/v1/api_pb";
const client = createApiClient(WithdrawalService);

export const withdrawalService = {
  listWithdrawals: (
    request: ListWithdrawalsRequest,
  ): Promise<ListWithdrawalsResponse> => {
    return client.listWithdrawals(request);
  },

  createWithdrawal: (request: CreateWithdrawalRequest): Promise<Withdrawal> => {
    return client.createWithdrawal(request);
  },
};

export type {
  ListWithdrawalsRequest,
  ListWithdrawalsResponse,
  CreateWithdrawalRequest,
  Withdrawal,
};
